import { selectOption } from '../../types/selectOption';
import { HttpClient } from '../httpClient';
import DivisionBillingSpecialist from '../models/divisionBillingSpecialist';
import User from '../models/user';
import DivisionRequest from '../requests/divisionRequest';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import DivisionResponse from '../responses/divisionResponse';
import DivisionsResponse from '../responses/divisionsResponse';

const httpClient = new HttpClient();

export const getDivision = async (id: number) => {
  return httpClient.get<DivisionResponse>({
    url: `/v1/divisions/${id}`,
    requiresToken: true,
  });
};

export const getDivisions = async () => {
  return httpClient.get<DivisionsResponse>({
    url: `/v1/divisions`,
    requiresToken: true,
  });
};

export const createDivision = async (Divisionrequest: DivisionRequest) => {
  return httpClient.post<DivisionResponse>({
    url: '/v1/admin/Divisions',
    payload: Divisionrequest,
    requiresToken: true,
  });
};

export const updateDivision = async (
  DivisionId: number,
  Divisionrequest: DivisionRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/Divisions/${DivisionId}`,
    payload: Divisionrequest,
    requiresToken: true,
  });
};

export const deleteDivision = async (DivisionId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/Divisions/${DivisionId}`,
    requiresToken: true,
  });
};

export const getBillingSpecialists = async () => {
  return httpClient.get<DataResponse<User[]>>({
    url: `/v1/divisions/BillingSpecialists`,
    requiresToken: true,
  });
};

export const getDivisionBillingSpecialists = async (divisionId: number) => {
  return httpClient.get<DataResponse<DivisionBillingSpecialist[]>>({
    url: `/v1/divisions/${divisionId}/BillingSpecialists`,
    requiresToken: true,
  });
};

export const getDivisionCount = async () => {
  return httpClient.get<DataResponse<number>>({
    url: `/v1/Divisions/GetCount`,
    requiresToken: true,
  });
};

export const getDivisionOptions = async () => {
  return httpClient.get<DataResponse<selectOption[]>>({
    url: `/v1/Divisions/Options`,
    requiresToken: true,
  });
};